module.exports = __webpack_public_path__ + "static/bottom_bar_1-41849c738afec89d3626f300382eba0d.png";